"use strict";
// METYCLE's receiving-account keys, shared between the backend (validation +
// PDF payment-block routing) and the frontend (sell-side Bank Account select).
// The full bank details stay server-side in
// backend/.../documents/templates/invoice-payment-accounts.ts.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENT_ACCOUNT_LABELS = exports.PAYMENT_ACCOUNT_KEYS = void 0;
exports.isPaymentAccountKey = isPaymentAccountKey;
exports.PAYMENT_ACCOUNT_KEYS = ['usd_airwallex_global', 'usd_airwallex_hk', 'eur_db'];
// Dropdown labels, mirroring Launchpad's "{bankName} — {bankCountry} ({CUR})".
exports.PAYMENT_ACCOUNT_LABELS = {
    usd_airwallex_global: 'Community Federal Savings Bank — United States (USD)',
    usd_airwallex_hk: 'Standard Chartered Bank (Hong Kong) Ltd — Hong Kong SAR (USD)',
    eur_db: 'Deutsche Bank — Germany (EUR)',
};
function isPaymentAccountKey(value) {
    return exports.PAYMENT_ACCOUNT_KEYS.includes(value);
}
//# sourceMappingURL=payment-accounts.js.map